import React, { useState } from 'react'
import useAsyncEffect from 'use-async-effect'
import AdminLoginFeature from '../../features/AdminLoginFeature'
import { getAllManufacturersAPI, getAllOperatorsAPI } from '../../utils/api'
import CustomLoader from '../../components/CustomLoader'
import type { ManufactureListType, OperatorListType } from '../../features/AdminLoginFeature/types'
import CustomSnackBar from '../../components/CustomSnackBar'
import { SnackBarMessageType } from '../../consts/SnackbarMessageTypes'
import { useAppSelector } from '../../reducers/hooks'

const AdminLoginPage: React.FC = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [manufacturerList, setManufacturerList] = useState<ManufactureListType[]>([])
  const [operatorList, setoperatorsList] = useState<OperatorListType[]>([])
  const platform = useAppSelector((state) => state.user.platform)
  const botType = useAppSelector((state) => state.user.botType)

  const [isError, setIsError] = useState<boolean>(false)

  useAsyncEffect(async () => {
    try {
      const [manufacturer, operators] = await Promise.all([
        getAllManufacturersAPI(platform, botType),
        getAllOperatorsAPI(platform, botType)
      ])
      if (manufacturer?.success === true && operators?.success === true) {
        setIsLoading(false)
        setManufacturerList(manufacturer?.payload)
        setoperatorsList(operators?.payload)
      }
    } catch (err) {
      setIsLoading(false)
      setIsError(true)
    }
  }, [])

  return (
    <>
      {isLoading
        ? <CustomLoader />
        : <AdminLoginFeature manufacturerList={manufacturerList} operatorList={operatorList} />
      }
      <CustomSnackBar isOpen={isError} onClose={setIsError} message={'Unable to fetch data, Please login again'} duration={5000} messageType={SnackBarMessageType.ERROR} />
    </>
  )
}

export default AdminLoginPage
